import app from '@/config';


export default {
	name: 'id',
	bind(el, binding) {
		el.setAttribute('data-test-id', binding.value);
	},
	update(el, binding) {
		el.setAttribute('data-test-id', binding.value);
	}
};
